export enum RegionName {
  PEE_DEE_COUNTIES = 'Pee Dee',
  LOW_COUNTY_COUNTIES = 'Lowcountry',
  MIDLANDS_COUNTIES = 'Midlands',
  UPSTATE_COUNTIES = 'Upstate',
}
